export default __webpack_public_path__ + "static/image-55-96a2308bae126b7cb341730ab2cbc20b.jpg";